import React, { useRef, useState } from "react";
import BreadcrumbPortal from "./BreadcrumbPortal";
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

const SearchPortal = ({ excludedPaths = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState(location.state?.search || "");
  const [required, setRequired] = useState("");
  const inputRef = useRef();

  const handleSubmit = () => {
    if (search === "") {
      setRequired("Kolom pencarian wajib diisi");
    } else {
      setRequired("");
      navigate("/pertanyaan/pencarian", { state: { search: search } });
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <div className="h-32 md:h-28 bg-gradient-to-b from-sky-800 to-gray-800 mb-4 md:mb-0 md:-mt-4">
      <div className="mx-auto max-w-[90rem] px-8 flex flex-wrap justify-between items-center">
        <BreadcrumbPortal excludedPaths={excludedPaths} />
        {/* Input Pertanyaan */}
        <div className="relative w-full  md:w-1/2">
          <div className="px-1 py-1 bg-white rounded border shadow-2xl">
            <input
              type="text"
              id="pertanyaan"
              value={search}
              ref={inputRef}
              required
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleKeyDown}
              className={`bg-white text-gray-800 w-full py-1.5 px-1.5 pr-10 border-2 border-sky-200  focus:outline-none
              ${
                required !== ""
                  ? "focus:border-red-500"
                  : "focus:border-sky-500"
              }
                 focus:drop-shadow-2xl"`}
              placeholder="Pencarian Pertanyaan"
            />
          </div>

          <button
            onClick={handleSubmit}
            className="absolute right-[7px] top-[7.5px] py-2.5 px-2.5 bg-sky-600 rounded-lg"
          >
            <FaSearch className="text-white text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchPortal;
